import { useRoute } from 'vue-router'

import {
  pickInvitationQueryForRoute,
  omitInvitationFromRouteQuery,
} from '@/features/auth/utils/authInvitationQuery.js'

const DEFAULT_ORIGIN = 'http://localhost'

function getFirstQueryValue(value) {
  return Array.isArray(value) ? value[0] : value
}

function appendActiveClubId(redirectUrl, activeClubId) {
  if (!activeClubId || !redirectUrl) return redirectUrl

  const url = new URL(redirectUrl, window.location.origin || DEFAULT_ORIGIN)
  url.searchParams.set('activeClubId', activeClubId)

  return `${url.pathname}${url.search}${url.hash}`
}

function isDefaultPostAuthRedirect(pathname) {
  return pathname === '/' || pathname === '/landing'
}

export function getRawRedirectUrlFromRoute(route) {
  return getFirstQueryValue(route?.query?.redirectUrl) ?? null
}

export function resolveClubSelectorRedirectUrl(queryRedirectUrl) {
  const rawRedirectUrl = getFirstQueryValue(queryRedirectUrl)

  if (!rawRedirectUrl) {
    return null
  }

  try {
    const url = new URL(rawRedirectUrl, DEFAULT_ORIGIN)

    if (isDefaultPostAuthRedirect(url.pathname)) {
      return null
    }

    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return null
  }
}

export function getClubSelectorPushQuery(routeQueryOrRedirectUrl, options = {}) {
  const routeQuery =
    typeof routeQueryOrRedirectUrl === 'string' || routeQueryOrRedirectUrl === undefined
      ? { redirectUrl: routeQueryOrRedirectUrl }
      : routeQueryOrRedirectUrl || {}

  const redirectUrl = resolveClubSelectorRedirectUrl(getFirstQueryValue(routeQuery.redirectUrl))
  const query = options.omitInvitation
    ? buildClubSelectorQueryWithoutInvitation(routeQuery)
    : pickInvitationQueryForRoute(routeQuery)

  if (redirectUrl) {
    query.redirectUrl = redirectUrl
  } else {
    delete query.redirectUrl
  }

  return query
}

function buildClubSelectorQueryWithoutInvitation(routeQuery = {}) {
  return omitInvitationFromRouteQuery(routeQuery)
}

export function useAuthRedirection() {
  const route = useRoute()
  const queryParams = route.query
  const activeClubId = getFirstQueryValue(queryParams.activeClubId)
  const redirectUrl = appendActiveClubId(
    getFirstQueryValue(queryParams.redirectUrl) || '/',
    activeClubId,
  )

  return { redirectUrl, activeClubId }
}
